import { Vue, Component } from 'vue-property-decorator'
import MapIconSvg from '~/assets/svg/marker.svg'
import MapSelectedIconSvg from '~/assets/svg/marker-selected.svg'
import MapIconNotAvailable from '~/assets/svg/marker-not-available.svg'
import LocationSvg from '~/assets/svg/location-order.svg?inline'
import CloseSvg from '~/assets/svg/close-popup.svg?inline'
import LocationDistrict from '~/types/api/LocationDistrict'
import SelectorArrowSvg from '~/assets/svg/link-arrow.svg?inline'
import FavoritesFarmSvg from '~/assets/svg/favorites_farm.svg?inline'
import UnavailableSvg from '~/assets/svg/unavailable.svg?inline'
import ExpectedSvg from '~/assets/svg/expected.svg?inline'
import AvailableSvg from '~/assets/svg/available.svg?inline'
import EllipseSvg from '~/assets/svg/ellipse_workTime.svg?inline'
import s from '~/utils/s'
import { ICartPickPointInfo } from '~/types/api/order/OrderPickpoint'
import BalloonContent from '~/components/general/popups/BalloonContent'

enum TypeTab {
  Map,
  List
}

interface Marker {
  id: string,
  selected: boolean,
  coords: number[],
  size: number[],
  url: any,
  pointData: ICartPickPointInfo,
  name: string,
  dateDelivery: Date | null
}

@Component
export default class PickupSelectorPopupMobile extends Vue {
  typeTap: TypeTab = TypeTab.List
  searchInput: string = ''
  coords: number[] = [55.996857, 92.912626]
  zoom: number = 14
  showSearchList: boolean = false
  selectedMapPickpoint: string = ''
  selectedListPickpoint: string = ''
  districtId: string = '0'
  showSelector: boolean = false

  beforeDestroy () {
    this.mountedComponents.forEach((instance) => {
      instance.$destroy()
      if (instance.$el.parentNode) { instance.$el.parentNode.removeChild(instance.$el) }
    })
    this.mountedComponents.clear()
  }

  get bounds () {
    const points = s(this.$store).orderPage.pickpoints.filter(e => e.point.lat && e.point.lng).map(e => e.point)
    const lat = [...points].sort((a, b) => a.lat - b.lat)
    const lng = [...points].sort((a, b) => a.lng - b.lng)
    return [
      [lat[lat.length - 1]?.lat, lng[0]?.lng],
      [lat[0]?.lat, lng[lng.length - 1]?.lng]
    ]
  }

  get pickpointMarkers (): Marker[] {
    return this.pickpointBySearch.filter(e => e.point).map(e => ({
      id: e.id,
      selected: e.id === this.selectedMapPickpoint,
      coords: [e.point.lat, e.point.lng],
      size: [20, 31],
      url: this.selectedMapPickpoint === e.id ? MapSelectedIconSvg : MapIconSvg,
      pointData: e.pickPointAmountInfo,
      name: e.nameForSite ? e.nameForSite : e.name,
      dateDelivery: e.pickPointAmountInfo.moreDetailed.providerDeliveryDate
    }))
  }

  get pickpointBySearch () {
    let list = s(this.$store).orderPage.pickpoints
    if (this.searchInput.length > 2) {
      const query = this.searchInput.toLowerCase()
      list = s(this.$store).orderPage.pickpoints.filter((e) => {
        const name = e.name.toLowerCase()
        const nameForSite = e.nameForSite?.toLowerCase()
        const address = e.address.toLowerCase()
        const description = e.description.toLowerCase()
        return name.includes(query) || address.includes(query) || description.includes(query) || nameForSite?.includes(query)
      })
    }

    return list
  }

  get pickpointsByFilterDiscrict () {
    let list = s(this.$store).orderPage.pickpoints
    if (this.districtId !== '0') {
      list = list.filter(e => e.district.id === this.districtId)
    }

    return list
  }

  get districtList () {
    const districtList: LocationDistrict[] = s(this.$store).orderPage.pickpoints
      .filter(e => e.district)
      .map(e => e.district)
    return districtList.reduce<LocationDistrict[]>((acc, current) => {
      const x = acc.find(item => item.id === current.id)
      if (!x) {
        return acc.concat([current])
      } else {
        return acc
      }
    }, [{
      id: '0',
      xmlId: '0',
      name: 'Все районы'
    }])
  }

  clickByMap (id: string) {
    this.selectedMapPickpoint = id
    this.selectPickpount()
  }

  clickBySearchList (id: string) {
    this.selectedMapPickpoint = id
    this.clearSearch()
    this.selectPickpount()
  }

  clearSearch () {
    this.searchInput = ''
    this.showSearchList = false
  }

  selectPickpount () {
    if (this.typeTap === TypeTab.Map && this.selectedMapPickpoint !== '') {
      s(this.$store).orderPage.setPickpointId(this.selectedMapPickpoint)
    } else if (this.typeTap === TypeTab.List && this.selectedListPickpoint !== '') {
      s(this.$store).orderPage.setPickpointId(this.selectedListPickpoint)
    }

    s(this.$store).general.closePopup()
  }

  mountedComponents = new Map<string, Vue>()

  mountBalloonComponent (e: Marker) {
    const containerId = `balloon-${e.id}`

    // Немного подождать, пока балун появится в DOM
    setTimeout(() => {
      const container = document.getElementById(containerId)
      if (!container) { return }

      // Если для этого id уже есть монтированный компонент — размонтируем, чтобы не было дублей
      const oldInstance = this.mountedComponents.get(e.id)
      if (oldInstance) {
        oldInstance.$destroy()
        if (oldInstance.$el.parentNode) {
          oldInstance.$el.parentNode.removeChild(oldInstance.$el)
        }
        this.mountedComponents.delete(e.id)
      }

      // Создаем новый экземпляр компонента балуна
      const BalloonConstructor = Vue.extend(BalloonContent)
      const instance = new BalloonConstructor({
        propsData: {
          point: {
            id: e.id,
            name: e.name,
            dateDelivery: e.dateDelivery,
            amountInPharmacy: e.pointData.moreDetailed.amountInPharmacy,
            amountInProvider: e.pointData.moreDetailed.amountInProvider,
            amountNotAvailable: e.pointData.moreDetailed.amountNotAvailable
          }
        }
      })

      instance.$on('confirm', (id: string) => {
        this.clickByMap(id) // твой метод выбора маркера
        instance.$destroy()
        if (instance.$el.parentNode) { instance.$el.parentNode.removeChild(instance.$el) }
        this.mountedComponents.delete(id)
      // Закрыть балун, если нужно:
      // (this.$refs.map as any).$map.balloon.close()
      })

      instance.$mount()
      container.appendChild(instance.$el)

      this.mountedComponents.set(e.id, instance)
    }, 100)
  }

  selectDistrict (e: string) {
    this.districtId = e
    this.showSelector = false
  }

  getHeightBalloon (e: Marker) {
    let height = 130

    if (e.pointData.moreDetailed.amountInPharmacy > 0) { height += 40 }
    if (e.pointData.moreDetailed.amountInProvider > 0) { height += 80 }
    if (e.pointData.moreDetailed.amountNotAvailable > 0) { height += 60 }
    if (e.pointData.moreDetailed.amountInPharmacy === 0 &&
      e.pointData.moreDetailed.amountInProvider === 0 &&
      e.pointData.moreDetailed.amountNotAvailable > 0) { height = 130 }

    return height
  }

  renderMap () {
    return (
      <div class="pickup-selector-popup-mobile__wrapper">
        <div class="pickup-selector-popup-mobile__map">
          <client-only>
            <yandex-map {...{
              props: {
                coords: this.coords,
                zoom: this.zoom,
                bounds: this.bounds,
                'scroll-zoom': false,
                controls: [
                  'zoomControl'
                ],
                clusterOptions: {
                  cluster: {
                    clusterDisableClickZoom: false,
                    clusterIconColor: '#296654',
                    gridSize: 50,
                    zoomMargin: [100, 20, 60, 20],
                    openBalloonOnClick: false
                  }
                }
              }
            }}>
              {this.pickpointMarkers.map((e) => {
                const availableProduct = e.pointData.moreDetailed.amountInPharmacy > 0 || e.pointData.moreDetailed.amountInProvider > 0
                const height = this.getHeightBalloon(e)
                return (
                  <ymap-marker
                    key={`${e.id}_${e.selected}`}
                    props={{
                      'marker-id': e.id,
                      coords: e.coords,
                      clusterName: 'cluster',
                      icon: {
                        layout: 'default#imageWithContent',
                        imageHref: availableProduct ? e.url : MapIconNotAvailable,
                        imageSize: e.size,
                        imageOffset: [-e.size[0] / 2, -e.size[1]],
                        contentOffset: [0, 0]
                      },
                      options: {
                        openBalloonOnClick: true
                      },
                      properties: {
                        balloonContentBody: `<div id="balloon-${e.id}" class="yandex-balloon-content" style="height:${height}px; overflow: visible ! important; width: 260px;"></div>`
                      }
                    }}
                    on={{
                      click: () => {
                        setTimeout(() => {
                          this.mountBalloonComponent(e)
                        }, 100)
                      }
                    }}
                  />
                )
              })}
            </yandex-map>
          </client-only>
        </div>
        <div class="pickup-selector-popup-mobile__search-wrapper" {...{
          directives: [{
            name: 'VueClickOutside',
            value: () => this.clearSearch()
          }]
        }}>
          <div class="pickup-selector-popup-mobile__search">
            <div class="pickup-selector-popup-mobile__search-icon">
              <LocationSvg />
            </div>
            <input type="text"
              class="pickup-selector-popup-mobile__search-input"
              v-model={this.searchInput}
              onFocus={() => { this.showSearchList = true }}
              placeholder="Поиск по адресу" />
            <div class="pickup-selector-popup-mobile__search-clear" onClick={() => this.clearSearch()}>
              <CloseSvg />
            </div>
          </div>
          {this.showSearchList &&
            <div class="pickup-selector-popup-mobile__search-list">
              {this.pickpointBySearch.map(e => (
                <div class="pickup-selector-popup-mobile__search-list-item"
                  onClick={(event: MouseEvent) => {
                    event.stopPropagation()
                    this.clickBySearchList(e.id)
                  }}>
                  {e.nameForSite ? e.nameForSite : e.name}
                </div>
              ))}
            </div>
          }
        </div>
        {this.selectedMapPickpoint !== '' &&
          <div class="pickup-selector-popup-mobile__pickpoint-selected">
            {s(this.$store).orderPage.pickpoints.find(e => e.id === this.selectedMapPickpoint)?.nameForSite}
          </div>
        }
      </div>
    )
  }

  renderList () {
    return (
      <div class="pickup-selector-popup-mobile__list-wrapper">
        <div class="pickup-selector-popup-mobile__list-filter">
          <div {...{
            class: 'link-selector',
            directives: [{
              name: 'VueClickOutside',
              value: () => { this.showSelector = false }
            }]
          }}>
            <div {...{
              class: 'link-selector__selected',
              on: {
                click: () => { this.showSelector = !this.showSelector }
              }
            }}>
              <div class="link-selector__selected-text">
                {this.districtList.find(e => e.id === this.districtId)?.name}
              </div>
              <div class="link-selector__selected-arrow">
                <SelectorArrowSvg />
              </div>
            </div>
            {this.showSelector &&
              <div class="link-selector__list">
                {this.districtList.map(e => (
                  <div {...{
                    class: 'link-selector__item',
                    on: {
                      click: (event: MouseEvent) => {
                        event.stopPropagation()
                        this.selectDistrict(e.id)
                      }
                    }
                  }}>{e.name}</div>
                ))}
              </div>
            }
          </div>
        </div>
        <div class="pickup-selector-popup-mobile__list">
          {this.pickpointsByFilterDiscrict.map((e) => {
            const scheme = s(this.$store).orderPage.scheme
            let more: ICartPickPointInfo['moreDetailed'] | undefined = e.pickPointAmountInfo?.moreDetailed
            let isUnavailableOnly = false

            if (scheme === 'NEW' && e.pickPointAmountInfo?.moreDetailed) {
              more = e.pickPointAmountInfo.moreDetailed
              isUnavailableOnly =
              more.amountNotAvailable > 0 &&
              more.amountInPharmacy === 0 &&
              more.amountInProvider === 0
            }
            return (
              <div {...{
                class: {
                  'pickup-selector-popup-mobile__list-item': true,
                  'pickup-selector-popup-mobile__list-item_selected': e.id === this.selectedListPickpoint,
                  'pickup-selector-popup-mobile__list-item_disabled': isUnavailableOnly
                },
                on: {
                  click: () => {
                    if (!isUnavailableOnly) {
                      this.selectedListPickpoint = e.id
                      this.selectPickpount()
                      s(this.$store).orderPage.loadOrderPickPointsHub()
                    }
                  }
                }
              }}>

                <div class = "pickup-selector-popup-mobile__container">
                  <div class="pickup-selector-popup-mobile__item-info">
                    <div class="pickup-selector-popup-mobile__favorites-farm">
                      {e.isFavorite === true && (
                        <FavoritesFarmSvg/>
                      )}
                    </div>
                    <div class="pickup-selector-popup-mobile__item-info--aboutPickup">
                      <div class="pickup-selector-popup-mobile__item-name">
                        {e.nameForSite ? e.nameForSite : e.name}
                      </div>
                      <div class="pickup-selector-popup-mobile__address-name">
                        {e.address}
                      </div>
                      <div class = "pickup-selector-popup-mobile__workTime">
                        <p>{e.shortWorkTime}</p>
                        <EllipseSvg/>
                        <p>{e.phone}</p>
                      </div>
                    </div>
                  </div>
                  {scheme === 'NEW' && (
                    <div class="pickup-selector-popup-mobile__availability">
                      {e.pickPointAmountInfo.moreDetailed?.amountInPharmacy > 0 && (
                        <div class="status_available">
                          <AvailableSvg/>
                          <p>Товары есть в наличии: {e.pickPointAmountInfo.moreDetailed?.amountInPharmacy} </p>
                        </div>
                      )}

                      {e.pickPointAmountInfo.moreDetailed?.amountInProvider > 0 && (
                        <div class="status_expected">
                          <div class="status_expected--container">
                            <ExpectedSvg/>
                            <p class="status_expected--count">Товары ожидаются: {e.pickPointAmountInfo.moreDetailed?.amountInProvider}</p>
                          </div>
                          <p class="status_expected--date">Товары ожидаются в этой аптеке с {e.pickPointAmountInfo.moreDetailed?.providerDeliveryDate}</p>
                        </div>
                      )}

                      {e.pickPointAmountInfo.moreDetailed?.amountNotAvailable > 0 && (
                        <div class="status_unavailable">
                          <div class="status_unavailable--container">
                            <UnavailableSvg/>
                            <p class="status_unavailable--count">Товары недоступны в этой аптеке: {e.pickPointAmountInfo.moreDetailed?.amountNotAvailable}</p>
                          </div>
                          {isUnavailableOnly && (
                            <p class="status_unavailable--text">Выберите другую аптеку</p>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  renderTabSelector () {
    return (
      <div class="pickup-selector-popup-mobile__selector">
        <div {...{
          class: {
            'pickup-selector-popup-mobile__selector-item': true,
            'pickup-selector-popup-mobile__selector-item_selected': this.typeTap === TypeTab.List
          },
          on: {
            click: () => { this.typeTap = TypeTab.List }
          }
        }}>
          Список
        </div>
        <div {...{
          class: {
            'pickup-selector-popup-mobile__selector-item': true,
            'pickup-selector-popup-mobile__selector-item_selected': this.typeTap === TypeTab.Map
          },
          on: {
            click: () => { this.typeTap = TypeTab.Map }
          }
        }}>
          Карта
        </div>
      </div>
    )
  }

  renderTab () {
    if (this.typeTap === TypeTab.Map) {
      return this.renderMap()
    } else {
      return this.renderList()
    }
  }

  render () {
    return (
      <div class="pickup-selector-popup-mobile">
        <div class="pickup-selector-popup-mobile__header-wrapper">
          Выберите аптеку
        </div>
        <div class="pickup-selector-popup-mobile__selector-wrapper">
          {this.renderTabSelector()}
        </div>
        <div class="pickup-selector-popup-mobile__tab-wrapper">
          {this.renderTab()}
        </div>
      </div>
    )
  }
}
